import React from "react";
import { useParams, useHistory } from "react-router-dom";
import "./style.scss";
import Painel from "gp-painel";
import "gp-painel/dist/index.css";
import { Secured } from "../../component";
import { Permissions } from "../../Constantes/permissions.constants";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import imagemAvatar from "../../imagens/avatar.png";
import ModalConfirmacaoRecadastramento from "../Recadastramento/Componentes/Modal-Documentacao";

import {
  Col,
  Form,
  Row,
  Alert,
  Card,
  Progress,
  Button,
  message,
  Popover,
  Input,
  ConfigProvider,
  DatePicker,
} from "antd";
import ModalHistorico from "./modalHistorico";
import {
  Contato,
  Endereco,
  IdentificacaoPessoa,
} from "./Componentes/Componentes";
import StatusBeneficios from "../../component/StatusBeneficios";
import Parser from "html-react-parser";

import service from "./services";
import ModalFoto from "../../component/ModalFoto";

import moment from "moment";

import PermiteContato from "../../component/PermiteContato/PermiteContato";
import InputCPF from "./Componentes/Input-CPF";

import ModalDependente from "../../component/Dependentes/ModalDependente";
import IdentificacaoBase from "../../component/IdentificacaoDoSegurado/Identificacao-base";

import { RetificacaoContext } from "../../component/Context/RetificacaoContext";

import dayjs from "dayjs";

const statusAlert = {
  warn: { tipo: "warning", titulo: "Aviso" },
};

const Censo = () => {
  const [modoSomenteLeitura, setModoSomenteLeitura] = React.useState(true);
  const [form] = Form.useForm();
  const { idCenso } = useParams();
  const [valoresForm, setValoresForm] = React.useState({});
  const [ocultarEtapa2, setOcultarEtapa2] = React.useState(true);
  const [ocultarEtapa3, setOcultarEtapa3] = React.useState(true);
  const [mostrarModalHistorico, setMostrarModalHistorico] =
    React.useState(false);
  const [mostrarModalRepresentante, setMostrarModalRepresentante] =
    React.useState(false);
  const [existeBeneficioPensao, setExisteBeneficioPensao] =
    React.useState(false);
  const [exibeMensagemRepresentante, setExibeMensagemRepresentante] =
    React.useState(false);
  const [requerRepresentante, setRequerRepresentante] = React.useState(false);
  const [fotoBase64, setFotoBase64] = React.useState();
  const [documentoBase64, setDocumentoBase64] = React.useState();
  const [certidaoBase64, setCertidaoBase64] = React.useState();
  const [modalFotoEstaAberto, setModalFotoEstaAberto] = React.useState(false);
  const [loadingCenso, setLoadingCenso] = React.useState(true);
  const { Meta } = Card;

  const [ultimaFotoCensoBase64, setUltimaFotoCensoBase64] = React.useState();

  const [redirecionar, setRedirecionar] = React.useState(false);

  const [permiteTrocarDocumento, setPermiteTrocarDocumento] = React.useState();

  const [mostrarModalDependente, setMostrarModalDependente] =
    React.useState(false);

  const history = useHistory();
  const controleEtapa2 = (valor) => setOcultarEtapa2(!valor);

  const { dadosRetificacao, setDadosRetificacao } =
    React.useContext(RetificacaoContext);

  React.useEffect(() => {
    if (dadosRetificacao?.id) {
      setEmRetificacao(true);
    }
  }, [dadosRetificacao]);

  const [mostrarModalConfirmacao, setMostrarModalConfirmacao] =
    React.useState(false);

  const [dadosRetificacaoLocal, setDadosRetificacaoLocal] =
    React.useState(null);

  const [emRetificacao, setEmRetificacao] = React.useState(false);

  React.useEffect(() => {
    if (redirecionar) {
      history.push("/", { forceRedirect: true });
    }
  }, [redirecionar, history]);

  const handleValoresCPF = (dadosDoFormulario) => {
    setValoresForm(dadosDoFormulario);
    setRequerRepresentante(
      IdentificacaoPessoa.checandoDiferencaEntreDatas(
        dadosDoFormulario?.pessoa?.nascimento
      )
    );
    controleEtapa2(true);
  };

  React.useEffect(() => {
    form.setFieldsValue(valoresForm);
  }, [valoresForm]);

  React.useEffect(() => {
    let isMounted = true;

    if (idCenso) {
      service.getCenso(idCenso).then((resp) => {
        if (!isMounted) return;

        const rawData = resp.data;

        setDocumentoBase64(
          rawData.documentosBase64
            ? `data:application/pdf;base64,${rawData.documentosBase64}`
            : undefined
        );
        setCertidaoBase64(
          rawData.certidaoBase64
            ? `data:application/pdf;base64,${rawData.certidaoBase64}`
            : undefined
        );
        setFotoBase64(
          rawData.fotoBase64
            ? `data:image/jpeg;base64,${rawData.fotoBase64}`
            : undefined
        );

        setUltimaFotoCensoBase64(
          rawData.ultimaFotoCensoBase64
            ? `data:image/jpeg;base64,${rawData.ultimaFotoCensoBase64}`
            : undefined
        );

        const data = {
          ...rawData,
          pessoa: {
            ...rawData.pessoa,
             nascimento: toMomentOrNull(rawData.pessoa.nascimento),
          },
          pessoaBanco: {
            ...rawData.pessoaBanco,
            expedicaoPassaporte: toMomentOrNull(
              rawData.pessoaBanco.expedicaoPassaporte
            ),
            validadePassaporte: toMomentOrNull(
              rawData.pessoaBanco.validadePassaporte
            ),
            expedicaoCarteiraProfissional: toMomentOrNull(
              rawData.pessoaBanco.expedicaoCarteiraProfissional
            ),
            validadeCarteiraProfissional: toMomentOrNull(
              rawData.pessoaBanco.validadeCarteiraProfissional
            ),
            dataDeNascimento: toMomentOrNull(
              rawData.pessoaBanco.dataDeNascimento
            ),

            expedicaoIdentidade: toMomentOrNull(
              rawData.pessoaBanco.expedicaoIdentidade
            ),
            validadeHabilit: toMomentOrNull(
              rawData.pessoaBanco.validadeHabilit
            ),
            emissaoHabilit: toMomentOrNull(rawData.pessoaBanco.emissaoHabilit),
          },
        };

        if (data?.permiteTrocarDocumento !== undefined) {
          setPermiteTrocarDocumento(data.permiteTrocarDocumento);
        }

        // Benefício pensão
        setExisteBeneficioPensao(
          data?.beneficios?.filter((item) => item.pensao).length > 0
        );

        handleValoresCPF(data);
        setLoadingCenso(false);
      });
    }

    return () => {
      isMounted = false;
    };
  }, [idCenso]);

  const cancelar = () => {
    form.resetFields();

    setValoresForm({});
    setExibeMensagemRepresentante(false);
    setOcultarEtapa2(true);
    setOcultarEtapa3(true);
    setDocumentoBase64(undefined);
    setCertidaoBase64(undefined);
    setFotoBase64(undefined);
    setModalFotoEstaAberto(false);
    setMostrarModalHistorico(false);
    setPermiteTrocarDocumento(false);
    setModoSomenteLeitura(true);

    history.replace("/");
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // <-- Converte para Base64 de verdade
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const visualizarArquivo = async (file, tipoDocumento) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    if (tipoDocumento === "Documento") {
      setDocumentoBase64(file.url || file.preview);
    }

    if (tipoDocumento === "Certidao") {
      setCertidaoBase64(file.url || file.preview);
    }

    if (tipoDocumento === "Foto") {
      setFotoBase64(file.url || file.preview);
    }
  };

  const handleChangeDocumento = async (info, tipoDocumento, idCenso) => {
    if (!info) return;

    const file =
      info.file?.originFileObj ||
      info.file?.file ||
      info.file ||
      info?.target?.files?.[0];
    if (!file) return;

    const tiposDeArquivosValidos = ["application/pdf"];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    if (!tiposDeArquivosValidos.includes(file.type)) {
      message.error("Apenas arquivos PDF são permitidos.", 4);
      return;
    }

    if (file.size > maxFileSize) {
      message.error("O arquivo selecionado excede 5 MB.", 4);
      return;
    }

    try {
      const idArquivoAntigo = valoresForm.certidaoToken;

      // 🔹 Faz o upload para o backend primeiro
      const idArquivoNovoCDN = await service.trocarArquivo(
        file,
        idCenso,
        idArquivoAntigo,
        tipoDocumento
      );

      // 🔹 Se o backend retornou sucesso, só então atualiza o front
      const base64 = await getBase64(file);

      if (tipoDocumento === "Documento") {
        setDocumentoBase64(base64);
        valoresForm.arquivoDocumentos = file;
        valoresForm.documentosToken = idArquivoNovoCDN; // atualiza token
      } else if (tipoDocumento === "Certidao") {
        setCertidaoBase64(base64);
        valoresForm.arquivoCertidao = file;
        valoresForm.certidaoToken = idArquivoNovoCDN; // atualiza token
      }

      message.success("Arquivo trocado com sucesso!", 4);
    } catch (error) {
      console.error("Erro ao processar o arquivo:", error);
      message.error(
        "Erro ao trocar o arquivo. Nenhuma alteração foi feita.",
        4
      );
    }
  };

  const downloadArquivo = (base64String, fileName) => {
    // Verifica se a string Base64 já contém o prefixo correto
    if (!base64String?.startsWith("data:application/pdf;base64,")) {
      base64String = `data:application/pdf;base64,${base64String}`;
    }

    const link = document.createElement("a");
    link.href = base64String;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const imprimirComprovante = () => {
    service.visualizar(idCenso).catch(console.error);
  };

  const retificarCPF = (id, anoReferencia, cpf) => {
    service
      .obterCPF(cpf, true)
      .then((res) => res.data)
      .then((dados) => {
        dados = {
          ...dados,
          pessoa: {
            ...dados.pessoa,
            nascimento: toMomentOrNull(dados.pessoa.dataDeNascimento),
          },
          pessoaBanco: {
            ...dados.pessoaBanco,
            expedicaoPassaporte: toMomentOrNull(
              dados.pessoaBanco.expedicaoPassaporte
            ),
            validadePassaporte: toMomentOrNull(
              dados.pessoaBanco.validadePassaporte
            ),
            expedicaoCarteiraProfissional: toMomentOrNull(
              dados.pessoaBanco.expedicaoCarteiraProfissional
            ),
            validadeCarteiraProfissional: toMomentOrNull(
              dados.pessoaBanco.validadeCarteiraProfissional
            ),
            dataDeNascimento: toMomentOrNull(
              dados.pessoaBanco.dataDeNascimento
            ),

            expedicaoIdentidade: toMomentOrNull(
              dados.pessoaBanco.expedicaoIdentidade
            ),
            validadeHabilit: toMomentOrNull(dados.pessoaBanco.validadeHabilit),
            emissaoHabilit: toMomentOrNull(dados.pessoaBanco.emissaoHabilit),
          },
        };

        dados.id = id;
        dados.referencia = anoReferencia;

        setValoresForm(dados);

        setOcultarEtapa2(false);
        setOcultarEtapa3(false);

        form.setFieldsValue(dados);
      });
  };

  const toMomentOrNull = (value) => {
    if (!value) return null;
    if (moment.isMoment(value)) return value;

    const m = moment(
      value,
      ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601],
      true
    );

    return m.isValid() ? m : null;
  };

  const emitirComprovante = async (id) => {
    if (!id) {
      message.warning("Não foi possível emitir o comprovante.");
      return;
    }

    try {
      await service.visualizar(id);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Erro ao emitir o comprovante.";

      message.error(errorMessage, 4);
      console.error("Erro ao emitir comprovante:", error);
    }
  };

  const podeEmitirComprovante =
    valoresForm?.id && valoresForm?.dataConclusao && !emRetificacao;

  return (
    <>
      <Secured
        hasAnyRole={Permissions.RECADASTRAMENTO.TELA}
        isShowErro403={true}
      >
        <Form name="censo" form={form} disabled={modoSomenteLeitura}>
          <Card
            title="Benefício(s)"
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              paddingBottom: "10px",
              marginBottom: "1%",
            }}
            hidden={ocultarEtapa2}
          >
            <div style={{ float: "left", width: "calc(100% - 240px)" }}>
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ flex: 2 }}>
                  <Form.Item name={["pessoa", "nome"]} label="Nome">
                    <Input disabled />
                  </Form.Item>
                </div>

                <div style={{ flex: 1 }}>
                  <Form.Item
                    name={["pessoa", "cpf"]}
                    label="CPF"
                    className="cpf-sem-lupa"
                  >
                    <InputCPF readOnly />
                  </Form.Item>
                </div>
              </div>
              <div style={{ width: "100%", maxWidth: "200px" }}>
                <Form.Item label="Data de Nascimento">
                  <DatePicker
                    disabled
                    format="DD/MM/YYYY"
                    value={
                      valoresForm?.pessoa?.nascimento
                        ? dayjs(valoresForm.pessoa.nascimento)
                        : null
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </div>
              <div style={{ marginTop: "20px" }}>
                {valoresForm?.beneficios?.map((item, index) => (
                  <div key={index} style={{ width: "50%" }}>
                    <StatusBeneficios item={item} />
                  </div>
                ))}
              </div>
            </div>

            <div style={{ float: "right", width: "220px" }}>
              <Col
                xs={22}
                sm={22}
                md={24}
                lg={24}
                hidden={ocultarEtapa2}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Card
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    padding: 0,
                  }}
                  bodyStyle={{ padding: 0 }}
                >
                  <img
                    src={ultimaFotoCensoBase64 || imagemAvatar}
                    alt="Foto"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Card>
              </Col>
            </div>

            {/* Clear floats */}
            <div style={{ clear: "both" }} />

            <Row style={{ marginTop: "10px" }}>
              {valoresForm?.mensagens?.map((item, index) => (
                <Alert
                  key={index}
                  message={statusAlert[Object.keys(item)[0]].titulo}
                  description={Parser(item[Object.keys(item)[0]])}
                  type={statusAlert[Object.keys(item)[0]].tipo}
                  showIcon
                />
              ))}
            </Row>

            <Row type="flex" justify="end" style={{ marginTop: "2%" }}>
              <Col>
                <button
                  type="button"
                  className="btn btn-outline-dark mr-2"
                  onClick={() => {
                    cancelar();
                  }}
                >
                  <i className="fa fa-eraser" />
                  Limpar Busca
                </button>
              </Col>

              <Col>
                <button
                  type="button"
                  className="btn btn-outline-success mr-2"
                  onClick={() => setMostrarModalHistorico(true)}
                >
                  <i className="fa fa-search" />
                  Histórico
                </button>
              </Col>

              {podeEmitirComprovante && (
                <Col>
                  <button
                    type="button"
                    className="btn btn-outline-success mr-2"
                    onClick={() => emitirComprovante(valoresForm.id)}
                  >
                    <i className="fa fa-file" />
                    Comprovante
                  </button>
                </Col>
              )}
            </Row>
          </Card>

          <Card
            title={loadingCenso ? "" : "Identificação do Segurado"}
            loading={loadingCenso}
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <IdentificacaoBase
              modoSomenteLeitura={modoSomenteLeitura}
              disabled={modoSomenteLeitura}
              form={form}
              nomePrefix={["pessoaBanco"]}
              onSearchCPF={handleValoresCPF}
              handleValoresCPF={handleValoresCPF}
              onClear={cancelar}
              onRetificar={(id, anoReferencia) => {
                setValoresForm((prev) => ({
                  ...prev,
                  id: id,
                  referencia: anoReferencia,
                  dataReferenciaTela:
                    valoresForm?.referencia || new Date().getFullYear(),
                }));

                history.push("/", {
                  id: id,
                  referencia: anoReferencia,
                  cpf: form.getFieldValue(["pessoa", "cpf"]),
                });
              }}
            />

            <div style={{ marginTop: "1%" }}>
              <button
                hidden={ocultarEtapa2}
                type="button"
                className="btn btn-outline-dark mr-2"
                onClick={() => setMostrarModalDependente(true)}
              >
                <i className="fas fa-user" />
                Dependentes
              </button>
            </div>
          </Card>

          <div hidden={ocultarEtapa2}>
            <Painel subTitulo="Endereço">
              <Endereco nome="endereco" form={form} status={controleEtapa2} />
            </Painel>
          </div>

          <div hidden={ocultarEtapa2}>
            <Painel subTitulo="Contato(s)">
              <Contato nome="contato" />
            </Painel>
          </div>

          {!ocultarEtapa2 && <PermiteContato nome="pessoa" form={form} />}

          <Row gutter={10} style={{ marginTop: "1.0%" }}>
            <Col xs={26} sm={26} md={18} lg={18} hidden={ocultarEtapa2}>
              <Card
                title="Documentos necessários"
                style={{ display: ocultarEtapa2 ? "none" : "block" }}
              >
                <Row gutter={[10, 10]} align="stretch" justify="center">
                  <Col
                    xs={23}
                    sm={23}
                    md={23}
                    lg={23}
                    style={{ marginTop: "0.5%" }}
                  >
                    <Form.Item
                      name="arquivoCertidao"
                      rules={[
                        {
                          required: true,
                          message: "Por favor, insira o token Base64!",
                        },
                      ]}
                    >
                      <Card
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                        cover={
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {certidaoBase64 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                }}
                              >
                                <CheckCircleOutlined
                                  style={{ color: "green", marginRight: 8 }}
                                />
                                <div>Certidão Selecionada!</div>
                                <Progress percent={100} size="small" />
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                }}
                              >
                                <ExclamationCircleOutlined
                                  style={{ color: "orange", marginRight: 8 }}
                                />
                                <div>Selecione um Arquivo</div>
                                <Progress
                                  percent={2}
                                  size="small"
                                  status="exception"
                                />
                              </div>
                            )}
                          </div>
                        }
                        actions={[
                          <Row gutter={24}>
                            {permiteTrocarDocumento ? (
                              <>
                                <Col span={12}>
                                  <Button
                                    type="primary"
                                    block
                                    style={{ fontWeight: "bold" }}
                                    onClick={() =>
                                      downloadArquivo(
                                        certidaoBase64,
                                        "certidao.pdf"
                                      )
                                    }
                                    disabled={!certidaoBase64}
                                  >
                                    Baixar Arquivo
                                  </Button>
                                </Col>

                                <Col span={12}>
                                  <Button
                                    type="primary"
                                    block
                                    style={{
                                      fontWeight: "bold",
                                      backgroundColor: "#1677ff",
                                      borderColor: "#1677ff",
                                    }}
                                    disabled={false}
                                    onClick={() =>
                                      document
                                        .getElementById("upload-certidao")
                                        .click()
                                    }
                                  >
                                    Trocar Arquivo
                                  </Button>

                                  <input
                                    type="file"
                                    accept=".pdf"
                                    style={{ display: "none" }}
                                    id="upload-certidao"
                                    onChange={async (e) => {
                                      const file = e.target.files?.[0];
                                      if (file) {
                                        const reader = new FileReader();
                                        reader.onloadend = () =>
                                          setCertidaoBase64(reader.result);
                                        reader.readAsDataURL(file);
                                        handleChangeDocumento(
                                          { fileList: [file], file },
                                          "Certidao",
                                          valoresForm.id
                                        );
                                      }
                                    }}
                                  />
                                </Col>
                              </>
                            ) : (
                              <Col span={24}>
                                <Button
                                  type="primary"
                                  block
                                  style={{ fontWeight: "bold" }}
                                  onClick={() =>
                                    downloadArquivo(
                                      certidaoBase64,
                                      "certidao.pdf"
                                    )
                                  }
                                  disabled={!certidaoBase64}
                                >
                                  Baixar Arquivo
                                </Button>
                              </Col>
                            )}
                          </Row>,
                        ]}
                      ></Card>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col
              xs={22}
              sm={22}
              md={6}
              lg={6}
              hidden={ocultarEtapa2}
              style={{ display: "flex", alignItems: "stretch" }}
            >
              <Card
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "233px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  padding: 0,
                  margin: "0 auto",
                }}
                //onClick={() => setModalFotoEstaAberto((prev) => true)}
              >
                <img
                  src={fotoBase64 || imagemAvatar}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </Card>
            </Col>
          </Row>

          <Row
            type="flex"
            justify="end"
            style={{
              marginTop: "12px",
              display: ocultarEtapa3 ? "none" : "block",
            }}
          >
            <Row type="flex" justify="end">
              <Col>
                <button
                  type="button"
                  className="btn btn-outline-dark mr-2"
                  onClick={cancelar}
                >
                  <i className="fa fa-eraser" />
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={() => imprimirComprovante()}
                  className="btn btn-info"
                >
                  <i className="fa fa-file-download" />
                  Gerar Comprovante
                </button>
              </Col>
            </Row>
          </Row>

          <Form.Item name="documentoApresentado" hidden>
            <Input />
          </Form.Item>

          <ConfigProvider componentDisabled={false}>
            <ModalConfirmacaoRecadastramento
              disabled={false}
              show={mostrarModalConfirmacao}
              form={form}
              maskClosable={false}
              onCancel={() => {
                setMostrarModalConfirmacao(false);
                setDadosRetificacaoLocal(null);
              }}
              onConfirm={() => {
                if (!dadosRetificacaoLocal) return;

                const { id, anoReferencia, documentoApresentado } =
                  dadosRetificacaoLocal;

                setModoSomenteLeitura(false);
                setOcultarEtapa3(false);

                const ultimaFotoFormatada = valoresForm?.ultimaFotoCensoBase64
                  ? `data:image/jpeg;base64,${valoresForm.ultimaFotoCensoBase64}`
                  : undefined;

                const dadosRetificados = {
                  ...valoresForm,
                  mensagens: [],
                  id,
                  anoReferencia,
                  referencia: anoReferencia,
                  endereco: valoresForm.endereco,
                  contato: valoresForm.contato,
                  ultimaFotoCensoBase64: ultimaFotoFormatada,
                  documentoApresentado: form.getFieldValue(
                    "documentoApresentado"
                  ),

                  pessoa: {
                    ...valoresForm.pessoa,
                    nascimento: toMomentOrNull(valoresForm.pessoa.nascimento),
                  },

                  pessoaBanco: {
                    ...valoresForm.pessoaBanco,
                    expedicaoPassaporte: toMomentOrNull(
                      valoresForm.pessoaBanco.expedicaoPassaporte
                    ),
                    validadePassaporte: toMomentOrNull(
                      valoresForm.pessoaBanco.validadePassaporte
                    ),
                    expedicaoCarteiraProfissional: toMomentOrNull(
                      valoresForm.pessoaBanco.expedicaoCarteiraProfissional
                    ),
                    validadeCarteiraProfissional: toMomentOrNull(
                      valoresForm.pessoaBanco.validadeCarteiraProfissional
                    ),
                    dataDeNascimento: toMomentOrNull(
                      valoresForm.pessoaBanco.dataDeNascimento
                    ),
                    expedicaoIdentidade: toMomentOrNull(
                      valoresForm.pessoaBanco.expedicaoIdentidade
                    ),
                    validadeHabilit: toMomentOrNull(
                      valoresForm.pessoaBanco.validadeHabilit
                    ),
                    emissaoHabilit: toMomentOrNull(
                      valoresForm.pessoaBanco.emissaoHabilit
                    ),
                  },
                };

                setUltimaFotoCensoBase64(ultimaFotoFormatada);

                setValoresForm(dadosRetificados);

                setDadosRetificacao({
                  id,
                  referencia: anoReferencia,
                  cpf: form.getFieldValue(["pessoa", "cpf"]),
                  nome: form.getFieldValue(["pessoa", "nome"]),
                  dados: dadosRetificados,
                });

                history.push("/", {
                  id: id,
                  referencia: anoReferencia,
                  cpf: form.getFieldValue(["pessoa", "cpf"]),
                  nome: form.getFieldValue(["pessoa", "nome"]),
                  retificacao: true,
                });

                setMostrarModalConfirmacao(false);
                setDadosRetificacaoLocal(null);
              }}
            />
          </ConfigProvider>
        </Form>

        {mostrarModalHistorico && (
          <ModalHistorico
            show
            close={() => setMostrarModalHistorico(false)}
            onRetificar={(id, anoReferencia) => {
              const documentoApresentado = form.getFieldValue([
                "documentoApresentado",
              ]);
              setMostrarModalHistorico(false);

              const tipoConfirmacao = form.getFieldValue("tipoConfirmacao");

              setDadosRetificacao({
                id,
                referencia: anoReferencia,
                cpf: form.getFieldValue(["pessoa", "cpf"]),
                nome: form.getFieldValue(["pessoa", "nome"]),
                tipoConfirmacao,
                documentoApresentado,
              });

              setDadosRetificacaoLocal({
                id,
                anoReferencia,
                documentoApresentado,
              });
              setMostrarModalConfirmacao(true);
            }}
            cpf={form.getFieldValue(["pessoa", "cpf"])}
            nome={form.getFieldValue(["pessoa", "nome"])}
          />
        )}

        {modalFotoEstaAberto && (
          <ModalFoto
            open={modalFotoEstaAberto}
            close={() => setModalFotoEstaAberto(false)}
            setFoto={setFotoBase64}
            eRetificacao={idCenso ? true : false}
            idCenso={idCenso}
            idArquivoAntigo={valoresForm.fotoToken}
          />
        )}

        {mostrarModalDependente && (
          <ModalDependente
            show={mostrarModalDependente}
            close={() => setMostrarModalDependente(false)}
            cpf={form.getFieldValue("pessoa")?.cpf}
            somenteVisualizacao={modoSomenteLeitura}
            pessoaTitular={
              form.getFieldValue("pessoa") ? form.getFieldValue("pessoa") : null
            }
          />
        )}
      </Secured>
    </>
  );
};

export default Censo;
